<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-card>
      <v-card-title style="height: 64px">
        <span class="title pl-2">{{permission.name}}</span>
        <span class="grey--text px-2" v-if="editing">正在编辑</span>
        <v-spacer></v-spacer>
        <v-btn @click="goReadonly()" color="primary" flat v-if="editing">返回</v-btn>
      </v-card-title>
      <v-card-text>
        <v-container class="py-0" fluid grid-list-md>
          <v-form ref="permission">
            <v-layout wrap>
              <v-flex sm4 xs12>
                <v-text-field
                  label="权限名称"
                  prepend-icon="$vuetify.icons.permission"
                  v-model="permission.name"
                ></v-text-field>
              </v-flex>
              <v-flex sm4 xs12>
                <v-select
                  :items="typeItems"
                  label="权限类型"
                  prepend-icon="$vuetify.icons.lock"
                  v-model="permission.type"
                ></v-select>
              </v-flex>
              <v-flex sm4 xs12>
                <v-text-field
                  label="Shiro字段"
                  prepend-icon="$vuetify.icons.shiroStr"
                  v-model="permission.shiroStr"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  :rows="1"
                  auto-grow
                  label="权限描述"
                  prepend-icon="$vuetify.icons.description"
                  v-model="permission.description"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout class="mt-2 text-xs-right">
      <v-flex v-if="newItem">
        <v-btn :loading="submitLoading" @click="setPermission(permission)" class="mx-0" color="primary">提交</v-btn>
      </v-flex>
      <v-flex v-if="editing" xs12>
        <v-btn
          :loading="submitLoading"
          @click="setPermission(permission)"
          class="mx-0"
          color="primary"
        >提交更改
        </v-btn>
      </v-flex>
    </v-layout>

  </l-layout>
</template>

<script>
import {Permission} from '../../../object'

export default {
  name: 'permissionForm',
  props: {
    permission: {
      type: Object,
      default: () => {
        return new Permission()
      }
    }
  },
  data: () => ({
    submitLoading: false,
  }),
  computed: {
    newItem () {
      return this.$route.name === 'NewPermission'
    },
    editing () {
      return this.$route.name === 'EditPermission'
    },
    typeItems () {
      return Permission.TYPE_LIST
    }
  },
  methods: {
    async setPermission (permission) {
      this.submitLoading = true
      try {
        await this.$store.dispatch('userAdmin/setPermission', permission)
        this.$L.alert('success', '提交成功')
        this.$L.tab.close(this.$L.tab.current, false)
        this.$router.push({
          name: 'PermissionList',
          params: {refresh: true}
        })
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.submitLoading = false
      }
    },
    goReadonly () {
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: 'PermissionDetails',
          params: this.$route.params,
          query: this.$route.query
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
